import { FC } from "react";
import { Box, Stack, Title } from "@mantine/core";
import { Stream } from "../Widgets/Stream";
import { UpcomingGames } from "../Widgets/UpcomingGames";
import { SponsorAd } from "../../../../Components/SponsorAd";
import { MatchCenterHero } from "../Widgets/MatchCenterHero";
import { TournamentStats } from "../Widgets/TournamentStats";
import { ResultCards } from "../Widgets/ResultCards";
import { MiniLeaderboard } from "../Widgets/MiniLeaderboard";
import { TopscorerHighlight } from "../Widgets/TopscorerHighlight";
import { useIsDesktop } from "../../../../hooks/useIsDesktop.ts";

export const Homepage: FC<{ isDesktop?: boolean }> = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack gap="lg" mt="md">
      <MatchCenterHero />

      {!isDesktop && (
        <>
          <Stream />
          <SponsorAd />
        </>
      )}

      <ResultCards maxGames={6} />
      <UpcomingGames maxGames={6} />

      <Box>
        <Title order={3} mb="sm">
          Statistiken
        </Title>
        <Stack gap="lg">
          <MiniLeaderboard maxTeams={5} />
          <TopscorerHighlight maxPlayers={5} />
          <TournamentStats />
        </Stack>
      </Box>
    </Stack>
  );
};
